<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <h2>Detinator/Utilizator</h2>
        <v-text-field label="Localitate" v-model="document.locality">
        </v-text-field>

        <v-text-field label="Strada" v-model="document.street"> </v-text-field>

        <v-text-field label="Numar" v-model="document.number"> </v-text-field>

        <v-text-field label="Judet/Sector" v-model="document.county">
        </v-text-field>

        <v-text-field label="CUI" v-model="document.cui"> </v-text-field>

        <v-text-field label="J" v-model="document.j"> </v-text-field>

        <h2>RVT a constatat:</h2>

        <v-switch
          label="Centrala este instalata cu respectarea distantelor minime atat
           in interiorul incaperii, cat si la evacuarea gazelor arse in exterior"
          v-model="document.isThermalPowerMountedFollowingDistances"
          class="mx-2"
        >
        </v-switch>

        <v-switch
          label="Circuitul hidraulic al centralei a fost aerisit inainte de prima aprindere,
           iar instalatia hidraulica si radiatorele sunt curatate si intretinute conform
            certificatului de garantie"
          v-model="document.isHidraulicCircuitValid"
          class="mx-2"
        >
        </v-switch>

        <v-switch
          label="Racordarea la gaz respecta conditiile din proiect si
           asigura debit si presiune constante conform datelor tehnice ale centralei"
          v-model="document.isGasConnectionValid"
          class="mx-2"
        >
        </v-switch>

        <v-switch
          label="In cazul existentei unui boiler de preparare ACM cu sistem de protectie
           anticoroziune PROTECH, s-a verificat conectrea si functionarea acestuia"
          v-model="document.isACMChecked"
          class="mx-2"
        >
        </v-switch>

        <v-switch
          label="Utilizatorul a luat cunostinta de informatiile din certificatele de garantie si
           instructiunile de utilizare si intretinere ale echipamentului"
          v-model="document.isUserInstructed"
          class="mx-2"
        >
        </v-switch>

        <v-switch
          label="Termostat de camera"
          v-model="document.hasThermostat"
          class="mx-2"
        >
        </v-switch>
        <v-switch
          label="Stabilizator de tensiune"
          v-model="document.hasStabilizer"
          class="mx-2"
        >
        </v-switch>

        <h2>Am dat urmatoarele dispozitii</h2>
        <v-switch
          label="Termostat de camera"
          v-model="document.needsThermostat"
          class="mx-2"
        >
        </v-switch>
        <v-switch
          label="Stabilizator de tensiune"
          v-model="document.needsStabilizer"
          class="mx-2"
        >
        </v-switch>

        <v-text-field label="Note" v-model="document.notes"> </v-text-field>

        <v-text-field
          label="Functionarea aparatului conform raport de verificari si probe"
          v-model="document.livretNumber"
        >
        </v-text-field>

        <v-text-field
          label="Delegatul montatorului/repartitorului/intretinatorului"
          v-model="document.delegate"
        >
        </v-text-field>

        <SignaturePad ref="signatureRef" />

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
          <v-btn @click="preview" color="primary">Previzualizare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import SignaturePad from '@/components/documents/SignaturePad.vue';
import { busEvent } from '../../main';

export default {
  components: {
    SignaturePad,
  },
  data() {
    return {
      valid: true,
      document: {
        type: 'report',
        locality: '',
        street: '',
        number: '',
        county: '',
        cui: '',
        j: '',
        devicePlace: '',
        hasThermostat: false,
        hasStabilizer: false,
        needsThermostat: false,
        needsStabilizer: false,
        notes: '',
        delegate: '',
        livretNumber: '',
        signature: null,
      },
    };
  },
  async created() {
    // check if we're on edit screen
    if (this.$route.name === 'Editare raport') {
      const document = await this.$store.dispatch('documents/getDocument', {
        clientId: this.$route.params.clientId,
        documentId: this.$route.params.id,
      });

      this.document = {
        ...document.props,
        documentId: document.id,
      };
      this.$refs.signatureRef.setSignature(document.props.signature);
    } else {
      const lastLivret = await this.$store.dispatch(
        'documents/getLastDocument',
        {
          documentType: 'livret',
        }
      );
      const createdAt = new Date(lastLivret.createdAt);
      const formattedDate = `${createdAt.getDate()}-${
        createdAt.getMonth() + 1
      }-${createdAt.getFullYear()}`;
      this.document.livretNumber = `RTS ${lastLivret.number}/${formattedDate}`;
    }
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        if (this.$route.name === 'Editare raport') {
          this.$store
            .dispatch('documents/update', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit('succesPopupCreated', 'Procesul verbal a fost editat');
              this.$router.back();
            });
        } else {
        this.$store
          .dispatch('documents/create', {
            clientId: this.$route.params.clientId,
            body: this.document,
          })
          .then(() => {
            busEvent.$emit('succesPopupCreated', 'Proces verbal a fost creat');
            this.$router.back();
          });
        }
      }
    },
    async preview() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        const response = await this.$store.dispatch('documents/preview', {
          clientId: this.$route.params.clientId,
          body: this.document,
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const fileName =
          response.headers['content-disposition'].match("filename='(.*)'");
        fileLink.setAttribute('download', fileName[1]);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
      }
    },
  },
};
</script>

<style>
</style>
